var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { get } from 'lodash-es';
import { useMobile } from '../hooks/use-mobile';
import { useResizeObserver } from '../hooks/use-resize-observer';
export var Image = function Image(props) {
  var className = props.className,
    src = props.src,
    _props$style = props.style,
    style = _props$style === void 0 ? {} : _props$style,
    imgProps = __rest(props, ["className", "src", "style"]);
  var imgRef = useRef(null);
  var mobile = useMobile();
  var _useState = useState(false),
    loaded = _useState[0],
    setLoaded = _useState[1];
  var _useState2 = useState('auto'),
    minHeight = _useState2[0],
    setMinHeight = _useState2[1];
  useResizeObserver(function () {
    var _a;
    var clientWidth = (_a = imgRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth;
    var aspectRatio = get(props, "src.".concat(mobile ? 'mobile' : 'web', ".aspectRatio"), 0);
    if (!clientWidth || !aspectRatio) {
      return;
    }
    setMinHeight(clientWidth / aspectRatio);
  }, imgRef);
  var wrapStyle = Object.assign({
    minHeight: loaded ? undefined : minHeight
  }, style);
  return mobile ? _jsx("div", Object.assign({}, imgProps, {
    ref: imgRef,
    style: wrapStyle,
    className: className
  }, {
    children: _jsx(LazyLoadImage, {
      onLoad: function onLoad() {
        return setLoaded(true);
      },
      className: className,
      src: src === null || src === void 0 ? void 0 : src.mobile.path,
      visibleByDefault: true
    })
  })) : _jsx("div", Object.assign({}, imgProps, {
    ref: imgRef,
    style: wrapStyle,
    className: className
  }, {
    children: _jsx(LazyLoadImage, {
      onLoad: function onLoad() {
        return setLoaded(true);
      },
      className: className,
      src: src === null || src === void 0 ? void 0 : src.web.path
    })
  }));
};